import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=0208c356&scoped=true&lang=pug&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208c356",
  null
  
)

export default component.exports